import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-brand-blue" data-id="element-56" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="83m6xohadewc">
        <p className="inline-block rounded-md bg-brand-red px-2 py-0.5 text-xs font-semibold uppercase tracking-widest text-white" data-id="element-58" data-mp="m46okhbgt4o9">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/85" data-id="element-59" data-mp="vui4714ih2az">
          Podés seguir buscando fichas, juegos, planificaciones y evaluaciones
          de inglés en diferentes lugares, dedicando horas a organizar cada
          clase. O podés comenzar hoy con un sistema que reúne los contenidos y
          recursos necesarios para preparar tus clases de manera más ordenada.
        </p>
        <h2 id="cierre" className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-60" data-mp="2c56e4c4hyjn3">
          No necesitás crear cada actividad desde cero.{' '}
          <span className="text-brand-yellow" data-id="element-61" data-mp="2m2b2milter72">
            Necesitás una estructura que te ayude a enseñar.
          </span>
        </h2>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-brand-yellow bg-white p-3 text-brand-ink" data-id="element-62" data-mp="2r3i9mfg4vmco">
          <p className="font-display text-base font-bold uppercase leading-tight text-brand-blue" data-id="element-63" data-mp="2v1fzlkhqach4">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-2xl font-bold uppercase tracking-wide" data-id="element-64" data-mp="34ssivnpgnubj">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-xs text-brand-muted sm:text-sm" data-id="element-65" data-mp="39r3ua2vemcvv">
            Valor de los bonos:{' '}
            <span className="font-bold text-brand-red line-through" data-id="element-66" data-mp="3et2vp77l2zq6">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="mt-1 font-display text-5xl font-bold leading-none tracking-tight text-brand-red sm:text-6xl" data-id="element-67" data-mp="3iqqtqj4kp8ma">
            <span className="text-3xl text-brand-blue sm:text-4xl" data-id="element-68" data-mp="1epihjinajnfl">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-69" data-mp="1sh6pd9qibpqr">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-brand-muted" data-id="element-70" data-mp="1nodoiwy5t1jy">
            <span className="flex items-center gap-1" data-id="element-71" data-mp="22gnyk14ywlrh">
              <ZapIcon size={12} className="text-brand-blue" data-id="element-72" data-mp="1xeyig72w1hwj" />
              Acceso Inmediato
            </span>
            <span className="text-brand-muted/50" data-id="element-73" data-mp="2bezkvqyswxe4">•</span>
            <span data-id="element-74" data-mp="27ded2k14j9as">Entrega Digital</span>
            <span className="text-brand-muted/50" data-id="element-75" data-mp="27efm6iykxlpv">•</span>
            <span className="flex items-center gap-1" data-id="element-76" data-mp="h0ynlaiwgig5">
              <ShieldCheckIcon size={12} className="text-brand-green" data-id="element-77" data-mp="h3ksf2eeojuo" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}